import { isInteractiveQuestionPin, Pin, PinTheme, PinThemeEntry, PinType } from '@lessonup/pins-shared';
import { cloneDeep } from 'lodash';
import { getResetablePinComponentSettings } from './pinThemePinComponentSettingsHandler.utils';
import { getResetablePinSettings } from './pinThemePinSettingsHandler.utils';

// @TODO https://lessonup.atlassian.net/browse/ED-1481
export function isInteractiveQuestionPinType(pinType: PinType) {
  return isInteractiveQuestionPin({ type: pinType } as Pin);
}

export function getPinThemeSettings(theme: PinTheme, pinType?: PinType): PinThemeEntry {
  const colorSetKey = pinType && isInteractiveQuestionPinType(pinType) ? 'interactive' : 'default';
  return theme[colorSetKey];
}

export function getStripDownPin(pin: Pin) {
  const pinClone = cloneDeep(pin);
  const pinSettingsKeys = getResetablePinSettings(pinClone);

  pinSettingsKeys.forEach((pinSettingKey) => {
    delete pinClone.settings[pinSettingKey as never];
  });

  pinClone.pinComponents.forEach((pinComponent) => {
    const pinComponentSettingsKeys = getResetablePinComponentSettings(pinComponent);
    pinComponentSettingsKeys.forEach((pinComponentSettingKey) => {
      delete pinComponent.settings[pinComponentSettingKey as never];
    });
  });

  return pinClone;
}
